import { render, staticRenderFns } from "./TheLogo.vue?vue&type=template&id=0896da9e"
import script from "./TheLogo.vue?vue&type=script&lang=js"
export * from "./TheLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports